module.exports = __webpack_public_path__ + "img/btn.41be2408.png";